import divisa from './divisa';

export default {
    namespaced: true,
    modules: {
        divisa
    },
};